import React, { useState } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '../../components/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ONBOARDING_ENABLED } from './onboardingConfig';
import { copy } from './copy';

const DISMISS_KEY = 'fd_onboarding_banner_dismissed';
const MAX_DISMISS = 2;

// Slim nudge shown to users who SKIPPED onboarding. Vanishes permanently after
// completion (status !== 'skipped') or two dismissals.
export default function OnboardingBanner() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => {
    const n = parseInt(window.localStorage.getItem(DISMISS_KEY) || '0', 10);
    return Number.isNaN(n) ? 0 : n;
  });

  if (!ONBOARDING_ENABLED) return null;
  if (userProfile?.onboarding?.status !== 'skipped') return null;
  if (dismissed >= MAX_DISMISS) return null;

  const dismiss = () => {
    const n = dismissed + 1;
    window.localStorage.setItem(DISMISS_KEY, String(n));
    setDismissed(n);
  };

  return (
    <Box
      role="region"
      aria-label={copy.banner.text}
      sx={{
        display: 'flex', alignItems: 'center', gap: 1.5,
        px: 2, py: 1,
        bgcolor: 'background.paper',
        borderBottom: 1, borderColor: 'divider',
      }}
    >
      <Typography variant="body2" sx={{ color: 'text.secondary', flex: 1 }}>
        {copy.banner.text}
      </Typography>
      <Button size="small" color="primary" onClick={() => navigate('/welcome')}>
        {copy.banner.cta}
      </Button>
      <IconButton size="small" aria-label={copy.banner.dismiss} onClick={dismiss} sx={{ color: 'text.secondary' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
